export const OVERVIEW_UNITS_ENUM = {
  HOURS: 'hours',
  PERCENTAGE: 'percentage',
  FTE: 'fte'
};

export const DEFAULT_OVERVIEW_UNIT = OVERVIEW_UNITS_ENUM.FTE;
